import { Content } from '@leverege/ui-elements'
import React from 'react'

import AnalyticsContext from '../analytics/AnalyticsContext'
import AlertsDonutChart from './components/AlertsDonutChart'

import useAlertsEvents from '../hooks/useAlertsEvents'
import S from './Alerts.css'
import ActiveAlerts from './components/ActiveAlerts'
import AlertsBarChart from './components/AlertsBarChart'
import AlertsTable from './components/AlertsTable'

export default function Alerts( props ) {
  const { parentItem } = props

  const { result } = useAlertsEvents( props )

  return (
    <AnalyticsContext store={parentItem}>
      <Content>
        <Content.Area className={S.area}>
          <div className={S.grid}>
            <ActiveAlerts
              {...props}
              result={result}
              type="person"
              label="Active Alerts"/>
            <AlertsDonutChart 
              result={result} />
            <AlertsBarChart {...props} result={result}/>
            <AlertsTable className={S.table} result={result} {...props}/>
          </div>
        </Content.Area>
      </Content>
    </AnalyticsContext>
  )
}
